import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { Input, Select } from "../../../../controls";
import { RandomCode } from "../../../../hooks/Method";
import InventoryFields from "./InventoryFields";

const StandardProd = (props) => {
  const { setValues, values, handleInpChg, SkuTypes } = props;

  useEffect(() => {
    if (values.prodType !== 2) {
      setValues((j) => ({ ...j, skuCode: j.skuCode || RandomCode() }));
    } else {
      setValues((j) => ({ ...j, skuCode: "" }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.prodType]);

  return (
    <>
      <Grid item xs={12} md={4}>
        <Select
          label="SKU Code Type"
          name="skuType"
          value={values.skuType}
          onChange={handleInpChg}
          options={SkuTypes}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <Input
          label="SKU Code"
          name="skuCode"
          value={values.skuCode}
          inputProps={{ maxLength: 100 }}
          onChange={handleInpChg}
        />
      </Grid>

      {/* ---------- Inventory Properties ---------- */}
      {values.prodType === 1 && <InventoryFields {...{ values, setValues }} />}
    </>
  );
};

export default StandardProd;
